module.exports = "/images/PaintBall.svg?ebcba33c3d8ecc7338f472f7c7435a1e";